var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMoodDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_460_2257",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_460_2257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 11C15.9167 11 16.2707 10.854 16.562 10.562C16.854 10.2707 17 9.91667 17 9.5C17 9.08333 16.854 8.72933 16.562 8.438C16.2707 8.146 15.9167 8 15.5 8C15.0833 8 14.7293 8.146 14.438 8.438C14.146 8.72933 14 9.08333 14 9.5C14 9.91667 14.146 10.2707 14.438 10.562C14.7293 10.854 15.0833 11 15.5 11ZM8.5 11C8.91667 11 9.27067 10.854 9.562 10.562C9.854 10.2707 10 9.91667 10 9.5C10 9.08333 9.854 8.72933 9.562 8.438C9.27067 8.146 8.91667 8 8.5 8C8.08333 8 7.72933 8.146 7.438 8.438C7.146 8.72933 7 9.08333 7 9.5C7 9.91667 7.146 10.2707 7.438 10.562C7.72933 10.854 8.08333 11 8.5 11ZM12 17.5C13.1333 17.5 14.1627 17.1793 15.088 16.538C16.0127 15.896 16.6833 15.05 17.1 14H6.9C7.31667 15.05 7.98767 15.896 8.913 16.538C9.83767 17.1793 10.8667 17.5 12 17.5ZM12 22C10.6167 22 9.31667 21.7373 8.1 21.212C6.88333 20.6873 5.825 19.975 4.925 19.075C4.025 18.175 3.31267 17.1167 2.788 15.9C2.26267 14.6833 2 13.3833 2 12C2 10.6167 2.26267 9.31667 2.788 8.1C3.31267 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.31233 8.1 2.787C9.31667 2.26233 10.6167 2 12 2C13.3833 2 14.6833 2.26233 15.9 2.787C17.1167 3.31233 18.175 4.025 19.075 4.925C19.975 5.825 20.6873 6.88333 21.212 8.1C21.7373 9.31667 22 10.6167 22 12C22 13.3833 21.7373 14.6833 21.212 15.9C20.6873 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6873 15.9 21.212C14.6833 21.7373 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z",
    fill: "white",
    fillOpacity: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMoodDark);
export default __webpack_public_path__ + "static/media/ic-mood-dark.d96c40a2d70a336524f37e82cbf9c546.svg";
export { ForwardRef as ReactComponent };